import { createFileRoute } from '@tanstack/react-router'
import MarketingModelosWhatsappPage from '@/pages/dashboard/marketing-modelos-whatsapp-page'
import { RequireModule } from '@/components/auth'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/marketing/modelos-whatsapp/',
)({
  component: function MarketingModelosWhatsappIndexRoute() {
    const { dashboardId } = Route.useParams()

    return (
      <RequireModule module={MODULES.MARKETING} dashboardId={dashboardId}>
        <MarketingModelosWhatsappPage />
      </RequireModule>
    )
  },
})
